import List from './list'
import Flow from './flow'
import Create from './create'
import Detail from './detail'

export default function(prefix, app) {
  return app
    .useRoute(`${prefix}/list/flow/detail/:id/:flow`, Detail)
    .useRoute(`${prefix}/list/flow/create/:id`, Create)
    .useRoute(`${prefix}/list/flow/:id`, Flow)
    .useRoute(`${prefix}/list`, List)
}
